<template>
  <div>
    <!--    顶部按钮-->
    <div class="app-container">
      <div style="height: 30px">
        <vxe-button @click="export2Excel" v-auth="`EXPORT`">导出</vxe-button>
        <vxe-button v-if="domain !== 'dealer'" v-auth="`BATCHAPPROVE`" @click="batchDialogVisible = true">批量审批</vxe-button>
        <vxe-button v-if="domain !== 'dealer'" v-auth="`ASSIGN`" @click="handleTransfer">指派</vxe-button>
        <div style="float: right; color: #848484; display: flex; line-height: 28px">
          <div v-if="!showFilter" style="float: right;display:flex">
            <a-select
              v-model="queryCondition.regionIds"
              placeholder="请选择经理部"
              mode="multiple"
              :maxTagCount="1"
              :filter-option="false"
              style="margin-right: 1rem;width:220px"
            >
              <a-select-option
                v-for="item in sectorList"
                :key="item.sectorId"
                :value="item.sectorId"
              >
                {{ item.sectorName }}
              </a-select-option>
            </a-select>
            <a-input v-model="queryCondition.applyNameOrCode" placeholder="请输入提报名称/提报编码" clearable style="width: 200px; margin-right: 1rem; height:28px" @keyup.enter.native="queryByPage(1)" />
          </div>
          <div>
            <vxe-button v-if="!showFilter" status="primary"  @click="queryByPage(1)">搜索</vxe-button>
            <vxe-button v-if="!showFilter"  class="filter-search-item" @click="resetForm(1)">重置</vxe-button>
            <vxe-button type="warning" @click="cb">
              {{ showFilter ? '收起' : '筛选' }}
            </vxe-button>
          </div>
        </div>
      </div>
      <!--    筛选拓展-->
      <div style="margin-top: 20px">
        <el-collapse-transition>
          <div v-if="showFilter">
            <SiftReimburse :data="queryCondition" sift-type="writeOff" :sector-list="sectorList" />
            <div slot="footer" style="text-align: center; padding-bottom: 10px;margin-bottom:10px">
              <vxe-button status="primary"  @click="queryByPage(1)">搜索</vxe-button>
              <vxe-button  @click="resetForm()">重置</vxe-button>
            </div>
          </div>
        </el-collapse-transition>
      </div>
      <!--提报列表-->
      <div>
        <!--提报列表-->
        <vxe-toolbar ref="toolbarRef" custom style="height:39px;margin-top:-10px;background: #F3F4F7;" />
        <vxe-table
          id="toolbar_reibursement"
          ref="xTable"
          :loading="LoadingTable"
          border
          show-header-overflow
          show-overflow
          align="center"
          class="mytable-scrollbar"
          :column-config="{ resizable: true }"
          stripe
          round
          :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
          :max-height="$store.state.app.height - 130 < 500 ? 500 : $store.state.app.height - 130"
          :scroll-y="{ enabled: false }"
          :row-config="{ isHover: true, height: 30, isCurrent: true }"
          :data="tableData"
          @cell-dblclick="cellClickEvent"
        >
          <vxe-column type="checkbox" width="60" align="center" />
          <vxe-column type="seq" title="序号" width="60" align="center" />
          <vxe-column :visible="false" title="id" field="id" width="100" />
          <!-- <vxe-column :visible="false" title="审批流程id" field="writeoffOrderId" width="100" /> -->
          <vxe-column :visible="false" title="历史审批流程id" field="writeoffHistOrderId" width="100" />
          <!-- <vxe-column title="申请月份" field="actMonth" width="100" /> -->
          <vxe-column :visible="false" title="活动计划编码" field="planCode" width="120" />
          <vxe-column title="活动提报编码" field="planApplyCode" width="120" />
          <vxe-column title="活动核销编码" field="writeoffCode" width="120"/>
          <vxe-column title="经理部名称" field="regionName" width="120" />
          <vxe-column :visible="false" title="经销商名称" field="dealerName" width="200" />
          <vxe-column title="经销商名称" field="dealerShortName" width="200" />
          <vxe-column title="申请人" field="createUserName" width="100" />
          <vxe-column title="活动提报名称" field="planApplyName" width="150" />
          <vxe-column title="预算类型" field="budgetTypeName" width="120" />
          <vxe-column title="一级来源" field="oneLevelName" width="120" />
          <vxe-column title="二级来源" field="twoLevelName" width="120" />
          <vxe-column title="三级来源" field="threeLevelName" width="120" />

          <vxe-column title="计划开始时间" field="planStartTime" width="120">
            <template #default="{ row }">
              <span>{{ row.planStartTime | dateFormat("yyyy-MM-dd") }}</span>
            </template>
          </vxe-column>
          <vxe-column title="计划结束时间" field="planEndTime" width="120">
            <template #default="{ row }">
              <span>{{ row.planEndTime | dateFormat("yyyy-MM-dd") }}</span>
            </template>
          </vxe-column>
          <vxe-column title="发起时间" field="writeoffFlowStartTime" width="160"/>
          <vxe-column title="实际时间" field="actualStartTime" width="120">
            <template #default="{ row }">
              <span v-if="row.actualStartTime">{{ row.actualStartTime | dateFormat("yyyy-MM-dd") }}</span>
            </template>
          </vxe-column>
          <vxe-column title="品系" field="strainsNameList" width="200" />
          <vxe-column title="车型代码" field="vehicleCodeList" width="200" />
          <vxe-column title="提报审批金额（元）" field="approveApplyCost" width="130" >
            <template #default="{ row }">
              {{ row.approveApplyCost | toThousandNumFilter }}
            </template>
          </vxe-column>

          <vxe-column title="集客实际" field="customerActual" width="100" />
          <vxe-column title="现场订车数" field="orderQuantity" width="100" />

          <vxe-column title="核销审核费用（元）" field="approveWriteoffCost" width="130" >
            <template #default="{ row }">
              <span v-if="row.approveWriteoffCost">{{ row.approveWriteoffCost | toThousandNumFilter }}</span>
            </template>
          </vxe-column>
          <vxe-column title="核销比例（%）" field="writeRate" width="110" />

          <vxe-column title="考评金额（元）" field="assessmentCost" width="120" />
          <vxe-column title="结算金额（元）" field="payAmounts" width="120">
            <template #default="{ row }">
              <span>{{ row.payAmounts | toThousandNumFilter }}</span>
            </template>
          </vxe-column>
          <vxe-column title="结算时间" field="payTime" width="160" />

          <vxe-column title="当前核销审批节点" field="writeoffNode" width="160" />
          <vxe-column title="当前核销节点审批人" field="writeoffAuditorNames" width="160" />
          <vxe-column title="核销状态" field="writeoffStatus" width="120">
            <template #default="{ row }">
              <span v-if="row.writeoffStatus === '0'">待反馈</span>
              <span v-if="row.writeoffStatus === '1'">待核销</span>
              <span v-if="row.writeoffStatus === '2'">审核中</span>
              <span v-if="row.writeoffStatus === '3'">审核通过</span>
              <span v-if="row.writeoffStatus === '4'">已驳回</span>
              <span v-if="row.writeoffStatus === '5'">超期放弃</span>
              <span v-if="row.writeoffStatus === '6'">不通过</span>
              <span v-if="row.writeoffStatus === '7'">放弃核销</span>
            </template>
          </vxe-column>

          <vxe-column field="address" title="操作" width="380" fixed="right" align="center">
            <template #default="{ row }">
              <div class="handle-box" style="height:30px">
                <a-button type="link" v-if="true" class="AMargin" v-auth="`VIEW`" @click="DetailedFun(row)">详细</a-button>
                <!-- cb009 -->
                <!-- <a-button type="link" v-if="+row.writeoffStatus > 1 && row.writeoffStatus !== '7'"
                  @click="viewApproveDetail(row)" v-auth="`REVIEWPROCESS`" 
                >审核流程</a-button> -->
                <a-button v-if="(row.writeoffStatus === '0' || row.writeoffStatus === '4') && hasDeletePermission"
                  status="primary" type="link" @click="deleteRow(row)"
                >删除</a-button>
                <a-button
                  type="link"
                  v-if="(+row.writeoffStatus < 2 || row.writeoffStatus == null || row.writeoffStatus === '4') && row.domain == 'dealer'"
                  class="AMargin" @click="reimburseFun(row)" v-auth="`FEEDBACK`"
                >反馈</a-button>
                <a-button
                  v-if="row.domain == 'dealer' && (row.writeoffStatus === '1' || row.writeoffStatus === '4') && (user.userId == row.writeoffAuditorIds || row.writeoffAuditorIds == null || row.writeoffAuditorIds === '')"
                  type="link" class="AMargin" @click="startApprove(row)"
                >发起核销</a-button>
                <a-button
                  v-if="(row.writeoffStatus === '0' || row.writeoffStatus === '1' || row.writeoffStatus === '4') && row.domain == 'dealer'"
                  type="link" class="AMargin color-red" @click="relinquishFun(row)"
                >放弃核销</a-button>
                <a-button v-if="row.writeoffStatus === '7'" type="link" class="AMargin color-red" @click="recoWriteoffFun(row)"
                >恢复核销</a-button>
              </div>
            </template>
          </vxe-column>
        </vxe-table>
        <vxe-pager
          v-show="!LoadingTable"
          :current-page="pagination.current"
          :page-size="pagination.size"
          :total="pagination.total"
          :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
          @page-change="changePage"
        />
        <vxe-modal v-model="showDetails" title="查看详情" width="600" height="400" :mask="false" :lock-view="false" resize>
          <template #default>
            <vxe-table
              border="inner"
              auto-resize
              show-overflow
              height="auto"
              :row-config="{isHover: true}"
              :show-header="false"
              :sync-resize="showDetails"
              :data="detailData"
            >
              <vxe-column field="label" width="40%" />
              <vxe-column field="value" />
            </vxe-table>
          </template>
        </vxe-modal>
        <!-- <el-pagination background layout="->,total, prev, pager, next" :total="pagination.total" :page-size="10" :current-page="pagination.current" @current-change="queryByPage" /> -->
      </div>
    </div>
    <!-- 导出对话框 -->
    <a-modal title="选择导出项" :visible.sync="dialogVisible" width="30%" @cancel="dialogVisible = false">
      <a-radio-group v-model="ExportItem">
        <a-radio :value="0">导出全部</a-radio>
        <a-radio :value="1">导出当前页</a-radio>
        <a-radio :value="2" :disabled="disabled">导出已选择项</a-radio>
      </a-radio-group>
      <span slot="footer" class="dialog-footer">
        <vxe-button @click="dialogVisible = false">取 消</vxe-button>
        <vxe-button status="primary" :loading="outExcelButtonLocading" @click="outExcel">确 定</vxe-button>
      </span>
    </a-modal>

    <el-dialog title="审批信息" :visible.sync="appdialogVisible" width="40%">
      <el-input
        v-model="approveMsg"
        type="textarea"
        placeholder="请输入审批意见"
        maxlength="300"
        show-word-limit
      />
      <span slot="footer" class="dialog-footer">
        <vxe-button type="primary" :loading="approveBtnLoading" @click="approveConfirmFun()">发起审批</vxe-button>
        <vxe-button @click="appdialogVisible = false">取 消</vxe-button>
      </span>
    </el-dialog>

    <a-modal title="批量审批信息" :visible.sync="batchDialogVisible" width="40%"  @cancel="onClose">
      <el-input
        v-model="batchApproveMsg"
        type="textarea"
        placeholder="请输入审批意见"
        maxlength="300"
        show-word-limit
      />
      <span slot="footer" class="dialog-footer">
        <vxe-button status="primary" :loading="approveBtnLoading" @click="approveBatch()">同意</vxe-button>
        <vxe-button @click="batchDialogVisible = false">取 消</vxe-button>
      </span>
    </a-modal>

    <el-dialog title="审批信息" :visible.sync="taskDialogVisible" width="80%">
      <vxe-table
        ref="xApprove"
        border
        show-header-overflow
        show-overflow
        :column-config="{ resizable: true }"
        stripe
        round
        :loading="approveLoading"
        max-height="370"
        align="center"
        :scroll-y="{ enabled: false }"
        :data="taskListData"
        :reserve="true"
        :row-config="{ isCurrent: true, isHover: true }"
      >
        <vxe-column type="seq" title="序号" width="60" />
        <vxe-column field="displayName" title="节点名称" />
        <vxe-column field="operatorName" title="审批人" />
        <vxe-column field="operateType" title="操作类型" />
        <!--<vxe-column field="amounts" title="申请金额" />-->
        <vxe-column field="approveCost" title="审批金额" />
        <vxe-column field="finishTime" title="处理时间" width="100" />
        <vxe-column field="approveMsg" title="审批意见" />
      </vxe-table>
    </el-dialog>

    <el-dialog title="审批信息" :visible.sync="transdialogVisible" width="40%">
      <div class="demo-input-suffix" style="padding-bottom: 20px;">
        转派人：
        <el-input v-model="operatorUser" placeholder="请选择转派的用户" style="width:35%" @focus="chooseUser" />
      </div>
      <el-input
        v-model="approveMsg"
        type="textarea"
        placeholder="请输入审批意见"
        maxlength="300"
        show-word-limit
      />
      <span slot="footer" class="dialog-footer">
        <vxe-button :loading="TransferApproveBtnLoading" status="primary" @click="transferApprove()">确定</vxe-button>
        <vxe-button @click="transdialogVisible = false">取 消</vxe-button>
      </span></el-dialog>

    <el-dialog title="选择用户" :visible.sync="userDialogVisible" width="75%">
      <div style="margin-bottom: 20px">
        <el-input v-model="userName" placeholder="输入用户名称" clearable :style="{ width: '80%' }" @change="handleFilter" />
        <vxe-button status="primary" class="filter-search-item" style="float: right" @click="handleFilter">查询</vxe-button>
      </div>
      <vxe-table
        ref="Xuser"
        border
        show-header-overflow
        show-overflow
        :column-config="{ resizable: true }"
        stripe
        round
        :loading="userLoading"
        max-height="350"
        align="center"
        :scroll-y="{ enabled: false }"
        :data="userLists"
        :reserve="true"
        :row-config="{ isCurrent: true, isHover: true }"
        :radio-config="{ strict: false, labelField: 'seq', trigger: 'row', isCurrent: true, isHover: true }"
      >
        <vxe-column type="radio" width="60" />
        <vxe-column :visible="false" field="id" title="用户id" />
        <vxe-column type="seq" title="序号" width="60" />
        <vxe-column field="name" title="用户名称" width="110" />
        <!-- <vxe-column field="roleNames" title="角色" /> -->
        <vxe-column field="department" title="所属组织结构" />
      </vxe-table>
      <vxe-pager
        :loading="userLoading"
        :current-page="userTablePage.currentPage"
        :page-size="userTablePage.pageSize"
        :total="userTablePage.totalResult"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
        @page-change="handlePageChange"
      />
      <span slot="footer" class="dialog-footer">
        <vxe-button @click="userDialogVisible = false">取 消</vxe-button>
        <vxe-button status="primary" @click="handleChooseUser()">确 定</vxe-button>
      </span>
    </el-dialog>

    <!-- 流程图对话框 -->
    <el-dialog title="提报审核流程" :visible.sync="checkFlowShow" width="80%">
      <checkFlow :data="budgetData" />
      <!-- <span slot="footer" class="dialog-footer">
        <vxe-button @click="checkFlowShow = false">返回</vxe-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import { findPlanApplyList, exportWriteOff, approveApplyOffBatch, saveApproveInfo, relinquishWriteoff, deleteActApply } from '@/api/actPlan'
import { http } from '@/api/activityCheck.js'
import { mapState } from 'vuex'
import SiftReimburse from '../components/SiftReimburse.vue'
import checkFlow from '../components/checkFlow.vue'
import { mapGetters } from 'vuex'
import { findList } from '@/api/user'
import { approveStart, findTaskInfos, approveRestart, findDisTaskInfos, transfer } from '@/api/wf_process.js'
//import { getRemainFee } from '@/api/amount'
import { dateFormat } from '@/utils/DateUtils'
// import permission from '@/directive/permission'
import { findSectorList } from '@/api/base-data'
import { Message } from 'element-ui';

const defaultListQuery = {
  page: 1,
  limit: 10,
  importance: undefined,
  domain: 'center',
  title: undefined,
  type: undefined,
  conditions: [],
  sort: '+id'
}

const defautFactor = {
  code: '',
  symbol: '',
  values: ''
}

const defaultWriteoffStatus = new Map([
  ['0', '待反馈'],
  ['1', '待核销'],
  ['2', '审核中'],
  ['3', '审核通过'],
  ['4', '已驳回'],
  ['5', '超期放弃'],
  ['6', '不通过'],
  ['7', '放弃核销']
])

const defaultState = new Map([
  ['0', '否'],
  ['1', '是']
])

export default {
  name: 'ActivityReimbursement',
  // directives: { permission },
  components: {
    SiftReimburse,
    checkFlow
  },
  data() {
    return {
      tableData: [], // 数据列表
      // 流程图对话框
      checkFlowShow: false,
      budgetData: [],
      showDetails: false,
      detailData: [],
      writeoffStatusMap: defaultWriteoffStatus,
      stateMap: defaultState,
      sectorList: [],
      userName: '',
      operatorUser: '',
      operatorId: '',
      factor: Object.assign({}, defautFactor),
      userLists: [],
      TransferApproveBtnLoading: false,
      userLoading: false,
      listQuery: Object.assign({}, defaultListQuery),
      userTablePage: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0
      },
      transdialogVisible: false,
      userDialogVisible: false,
      approveBtnLoading: false,
      batchDialogVisible: false,
      batchApproveMsg: '',
      taskDialogVisible: false,
      approveLoading: false,
      taskListData: [],
      appdialogVisible: false,
      currentRow: {},
      approveMsg: '',
      approveCost: '',
      dialog: {
        visiable: false,
        export: false
      },
      // 导出
      ExportItem: 0,
      dialogVisible: false,
      outExcelButtonLocading: false,
      disabled: true,
      LoadingTable: true, // 加载
      sort: 'apply_time desc',
      applyStatus: '2', // 提报审批状态：2审批通过
      siftType:'writeOff',//查询类型：writeOff核销，apply提报
      domain: 'center', // 当前用户角色 | center 表示为厂商
      amountData: {
        amountId: null,
        remainFee: null
      },
      remainFeeFlag: false,
      queryCondition: {
        applyNameOrCode: null,
        applyStatus: null,
        planWriteOffStatus: null,
        itemType: null,
        actMonthStart: null,
        actMonthEnd: null,
        budgetData: null,
        planCode: null,
        planApplyCode: null,
        regionIds: [],
        dealerIds: [],
        oneLevelCode: null,
        twoLevelCode: null,
        threeLevelCode: null
      },
      showFilter: false,
      pagination: {
        current: 1,
        size: 20,
        total: 0
      },
    }
  },
  computed: {
    ...mapState(['user/name']),
    // ...mapGetters(['userinfo']),
    ...mapGetters('account', ['user', 'permissions']),
    // queryCondition() {
    //   return this.$store.state.actVerListPage.queryCondition
    // },
    // pagination() {
    //   return this.$store.state.actVerListPage.pagination
    // },
    // showFilter() {
    //   return this.$store.state.actVerListPage.showFilter
    // }

    hasDeletePermission(){
      //console.error(JSON.stringify(this.permissions));
      let targetRecordLoop = null;
      for (const item of this.permissions) {
          if (item.id === "activityReimbursement") {
              targetRecordLoop = item;
              break;
          }
      }

      if (targetRecordLoop) {
          const hasDeletePermission = targetRecordLoop.operation.includes("DELETE");
          //console.error(`通过循环找到的记录，operation 数组是否包含 "DELETE": ${hasDeletePermission}`);
          return hasDeletePermission;
      }
      return false;
    }
  },
  watch: {
    appdialogVisible(val) {
      if (!val) {
        this.approveMsg = ''
        this.approveCost = ''
        this.currentRow = Object.assign({}, {})
      }
    },
    transdialogVisible(val) {
      if (!val) {
        this.operatorId = ''
        this.operatorUser = ''
        this.approveMsg = ''
        this.TransferApproveBtnLoading = false
      }
    }
  },
  created() {
    this.getSectorList()
    this.queryByPage()
    console.log(this.user.userId,'------this.user----');
    // 这个动作通常用于从后端API获取权限数据，并存储在Vuex的状态管理中
    this.$store.dispatch("fetchPermissions");
    // 打印每个权限对象的详细信息
    console.log('权限'+JSON.stringify(this.permissions))
    
  },
  mounted: function() {
    const $table = this.$refs.xTable
    const $toolbar = this.$refs.toolbarRef
    if ($table && $toolbar) {
      $table.connect($toolbar)
    }
    
  },
  methods: {
    // 审批流程图弹窗
    async checkFlowFun(row) {
      this.budgetData = []
      const id = row.writeoffApproveorder || row.writeoffApprovehistorder
      try {
        if (id.length > 1) {
          this.checkFlowShow = true
          this.budgetData = await http.getApproveProcess({ approveOrderId: id }).then(v => v.data)
        } else {
          this.$message.error('未找到审核记录')
        }
      } catch (error) {
        this.$message.error(error)
      }
    },
    checkColumnMethod({ column }) {
      if (column.field === 'id' || column.field === 'writeoffHistOrderId' || column.field === 'writeoffOrderId') {
        return false
      }
      return true
    },
    cellClickEvent({ row }) {
      this.detailData = [//{
  //      field: 'actMonth',
  //      title: '申请月份'
  //    },
      {
        field: 'writeoffStatus',
        title: '核销状态'
      },
      {
        field: 'planCode',
        title: '活动计划编码'
      },
      {
        field: 'planApplyCode',
        title: '活动提报编码'
      },
      {
        field: 'payRemark',
        title: '活动核销编码'
      },
      {
        field: 'regionName',
        title: '经理部名称'
      },
      {
        field: 'dealerName',
        title: '经销商名称'
      },
      {
        field: 'createUserName',
        title: '申请人'
      },
      {
        field: 'planApplyName',
        title: '活动提报名称'
      },
      {
        field: 'budgetTypeName',
        title: '预算类型'
      },
      {
        field: 'oneLevelName',
        title: '一级来源'
      },
      {
        field: 'twoLevelName',
        title: '二级来源'
      },
      {
        field: 'threeLevelName',
        title: '三级来源'
      },
      {
        field: 'planStartTime',
        title: '计划开始时间'
      },
      {
        field: 'planEndTime',
        title: '计划结束时间'
      },
      {
        field: 'writeoffFlowStartTime',
        title: '发起时间'
      },
      {
        field: 'actualStartTime',
        title: '实际时间'
      },
      {
        field: 'strainsNameList',
        title: '品系'
      },
      {
        field: 'vehicleCodeList',
        title: '车型代码'
      },
      {
        field: 'customerActual',
        title: '集客实际'
      },
      {
        field: 'orderQuantity',
        title: '现场订车数'
      },
      {
        field: 'approveApplyCost',
        title: '提报审批费用（元）'
      },
      {
        field: 'approveWriteoffCost',
        title: '核销审批费用（元）'
      },
      {
        field: 'writeRate',
        title: '核销比例（%）'
      },
      {
        field: 'assessmentCost',
        title: '考评金额（元）'
      },
      {
        field: 'payAmounts',
        title: '结算金额'
      },
      {
        field: 'payTime',
        title: '结算时间'
      },
      {
        field: 'writeoffNode',
        title: '当前核销审批节点'
      },
      {
        field: 'writeoffAuditorNames',
        title: '当前核销节点审批人'
      }].map(obj => {
        if (obj.field === 'writeoffStatus') {
          return { label: obj.title, value: this.writeoffStatusMap.get(row[obj.field]) }
        }
        if (obj.field === 'payFlag' || obj.field === 'sendVme') {
          return { label: obj.title, value: this.stateMap.get(row[obj.field]) }
        }
        return { label: obj.title, value: row[obj.field] }
      })
      this.showDetails = true
    },
    viewApproveDetail(row) {
      this.taskDialogVisible = true
      this.approveLoading = true
      const param = {
        orderId: row.writeoffOrderId || row.writeoffHistOrderId
      }
      if (row.writeoffStatus === '6') {
        findDisTaskInfos(param).then(res => {
          if (res.code === 1 && res.data) {
            this.taskListData = res.data
            this.approveLoading = false
          }
        })
      } else {
        findTaskInfos(param).then(res => {
          if (res.code === 1 && res.data) {
            this.taskListData = res.data
            this.taskListData.forEach(item => {
              if (!item.his) {
                item.operatorName = row.writeoffAuditorNames
                item.finishTime = '正在处理'
              }
            })
            this.approveLoading = false
          }
        }).finally(()=> this.approveLoading = false)
      }
    },
    handlePageChange({ currentPage, pageSize }) {
      this.userTablePage.currentPage = currentPage
      this.userTablePage.pageSize = pageSize
      this.listQuery.limit = pageSize
      this.listQuery.page = currentPage
      this.findUsers()
    },
    handleTransfer() {
      if (this.$refs.xTable.selection.length !== 1) {
        this.$message.warning('请勾选一条记录')
        return
      }
      const flag = this.$refs.xTable.selection.every(item => (item.writeoffStatus === '2' || item.writeoffStatus === '4'))
      if (flag === false) {
        this.$message.warning('所选记录中存在不是审批中或已驳回状态的记录')
        return
      }
      this.transdialogVisible = true
    },
    handleFilter() {
      this.listQuery.page = 1
      this.factor.code = 'nameOrAccount'
      this.factor.values = this.userName
      this.listQuery.conditions[0] = this.factor
      this.findUsers()
    },
    chooseUser() {
      this.userDialogVisible = true
      this.findUsers()
    },
    handleChooseUser() {
      const data = this.$refs['Xuser'].getRadioRecord()
      if (data) {
        this.operatorUser = data.name
        this.operatorId = data.id
      }
      this.userDialogVisible = false
    },
    findUsers() {
      this.userLoading = true
      findList(this.listQuery).then(res => {
        if (res.code === 1 && res.data) {
          this.userLists = res.data.list
          this.userTablePage.totalResult = res.data.total
          this.userLoading = false
        }
      })
    },
    transferApprove() {
      this.TransferApproveBtnLoading = true
      const signData = this.$refs.xTable.selection[0]
      const approveParam = {
        orderId: signData.writeoffOrderId,
        operator: this.operatorId,
        args: {
          amounts: signData.thisWriteoffCost,
          approveMsg: this.approveMsg,
          businessCode: signData.planApplyCode,
          businessName: signData.planApplyName
        }
      }
      transfer(approveParam).then(res => {
        if (res.code === 1) {
          signData.writeoffAuditorNames = res.data.operatorInfos[0].operatorNames
          signData.writeoffAuditorIds = res.data.operatorInfos[0].operatorIds
          signData.writeoffNode = res.data.approveNode
          saveApproveInfo(signData).then(v => {
            if (v.code === 1) {
              // this.reload()
              this.transdialogVisible = false
              this.TransferApproveBtnLoading = false
              this.reload()
            }
          })
        }
      })
    },
    approveConfirmFun() {
      // if (this.currentRow.thisWriteoffCost === 0) {
      //   this.$confirm({
      //   title: '提示',
      //   content: '核销费用为0, 是否继续发起核销？',
      //   onOk:() =>{
      //     this.approve()
      //   },
      //   onCancel() {
      //     Message({
      //       message: '已取消发起核销',
      //       type: 'info'
      //     });
      //   },
      // });
      // } else {
        this.approve()
      // }
    },
    approve() {
      //  发起审批
            // __设置审批费用__ - 将当前行的 `thisWriteoffCost`（本次核销费用）赋值给 `approveCost` 变量   ----不对，应该是把approveWriteoffCost
      // this.approveCost = this.currentRow.thisWriteoffCost
      this.approveCost = this.currentRow.approveWriteoffCost
      // __获取审批流程配置__ - 通过 Vuex store 分发 action，查询名为 `writeOffProcessMap` 的审批流程配置数
      this.$store.dispatch('SelectData/QuerySelect', ['writeOffProcessMap']).then(v => {
        // __查找匹配的审批流程__ - 在返回的审批流程映射表中，根据当前行的 `budgetTypeCode`（预算类型代码）查找对应的审批流程配置
        const obj = v.writeOffProcessMap.find(item => item.code === this.currentRow.budgetTypeCode)
        if (!obj) {
          this.$message.error('该预算类型未配置核销审批流')
          return
        }
        // 日常推广和新入网
        /*
        if (this.currentRow.budgetTypeCode === '1' || this.currentRow.budgetTypeCode === '13') {
          // 获取账期
          const data = {
            applyPlanId: this.currentRow.id,
            budgetType: this.currentRow.budgetTypeCode
          }
          this.approveBtnLoading = true
          getRemainFee(data).then(res => {
            if (res.code === 1) {
              this.amountData = res.data
              if (this.currentRow.writeoffStatus === '1') {
                this.approveStartFun(obj)
              } else if (this.currentRow.writeoffStatus === '4') {
                this.approveRestartFun()
              }
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
        */
          if (this.currentRow.writeoffStatus === '1') {
            this.approveStartFun(obj)
          } else if (this.currentRow.writeoffStatus === '4') {
            this.approveRestartFun()
          }
        //}
      })
    },
    approveStartFun(obj) {
      const approveParam = {
        processName: obj.value,
        args: {
          amounts: this.currentRow.thisWriteoffCost,
          approveMsg: this.approveMsg,
          approveCost: this.approveCost,
          businessCode: this.currentRow.planApplyCode,
          businessName: this.currentRow.planApplyName
        }
      }
      this.approveBtnLoading = true
      approveStart(approveParam).then(res => {
        if (res.code === 1) {
          this.currentRow.amountId = this.amountData.amountId
          this.currentRow.writeoffOrderId = res.data.orderId
          this.currentRow.writeoffNode = res.data.approveNode
          this.currentRow.writeoffFlowStartTime = dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
          this.currentRow.writeoffStatus = '2'
          this.currentRow.approveWriteoffCost = this.approveCost
          this.currentRow.writeoffAuditorNames = res.data.operatorInfos[0].operatorNames
          this.currentRow.writeoffAuditorIds = res.data.operatorInfos[0].operatorIds
          saveApproveInfo(this.currentRow).then(v => {
            if (v.code === 1) {
              this.$message.success('流程发起成功')
              this.approveBtnLoading = false
              this.appdialogVisible = false
              this.reload()
            }
          })
        }
      })
    },
    // 已驳回重新发起流程
    approveRestartFun() {
      const approveParam = {
        orderId: this.currentRow.writeoffOrderId,
        processName: this.currentRow.activityWriteOffProcessName,
        args: {
          amounts: this.currentRow.thisWriteoffCost,
          approveMsg: this.approveMsg,
          approveCost: this.approveCost,
          businessCode: this.currentRow.planApplyCode,
          businessName: this.currentRow.planApplyName
        }
      }
      this.approveBtnLoading = true
      approveRestart(approveParam).then(res => {
        if (res.code === 1) {
          this.currentRow.writeoffStatus = '2'
          this.currentRow.approveWriteoffCost = this.approveCost
          // this.currentRow.writeoffFlowStartTime = dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
          this.currentRow.writeoffNode = res.data.approveNode
          this.currentRow.writeoffAuditorNames = res.data.operatorInfos[0].operatorNames
          this.currentRow.writeoffAuditorIds = res.data.operatorInfos[0].operatorIds

          saveApproveInfo(this.currentRow).then(v => {
            if (v.code === 1) {
              this.$message.success('流程发起成功')
              this.approveBtnLoading = false
              this.appdialogVisible = false
              this.reload()
            }
          })
        }
      })
    },
    // 获取大区
    getSectorList() {
      findSectorList().then(res => {
        if (res.code === 1 && res.data) {
          this.sectorList = res.data
        }
      })
    },
    // 查询
    queryByPage(e) {
      if (e) this.pagination.current = e

      // 保存查询条件到store
      // this.$store.commit('actVerListPage/updatePagination', this.pagination)
      // this.$store.commit('actVerListPage/updateQueryCondition', this.queryCondition)

      this.LoadingTable = true
      const data = {
        page: this.pagination.current,
        limit: this.pagination.size,
        ...this.queryCondition,
        sort: this.sort,
        applyStatus: this.applyStatus, // 提报审批通过
        siftType: this.siftType // 查询类型：writeOff核销，apply提报
      }
      findPlanApplyList(data).then(res => {
        if (res.code === 1) {
          this.tableData = res.data.list
          this.pagination.total = res.data.total
          this.LoadingTable = false
        } else {
          this.$message.error(res.message)
        }
      })
    },
    approveBatch() {
      if (this.$refs.xTable.selection.length < 1) {
        this.$message.warning('请至少勾选一条记录')
        return
      }
      let flag = this.$refs.xTable.selection.every(item => item.writeoffStatus === '2')
      if (flag === false) {
        this.$message.warning('所选记录中存在不是审核中状态的记录')
        return
      }
      flag = this.$refs.xTable.selection.every(item => item.writeoffAuditorIds.indexOf(this.user.userId) != -1)
      if (flag === false) {
        this.$message.warning('所选记录中存在当前节点审批人不是当前用户的记录，请检查')
        return
      }
      this.$refs.xTable.selection.forEach(element => {
        element.approveMsg = this.batchApproveMsg
      })
      const data = this.$refs.xTable.selection
      this.approveBtnLoading = true
      approveApplyOffBatch(data).then(res => {
        if (res.code === 1) {
          this.$message.success('审批成功')
          this.approveBtnLoading = false
          this.batchDialogVisible = false
          this.reload()
        }
      })
    },
    changePage({ currentPage, pageSize }) {
      this.pagination.current = currentPage
      pageSize !== this.pagination.size && (this.pagination.current = 1)
      this.pagination.size = pageSize
      this.queryByPage()
    },
    resetForm() {
      // this.$store.commit('actVerListPage/resetQueryCondition')
      this.queryCondition =  {
        applyNameOrCode: null,
        applyStatus: null,
        planWriteOffStatus: null,
        itemType: null,
        actMonthStart: null,
        actMonthEnd: null,
        budgetData: null,
        planCode: null,
        planApplyCode: null,
        regionIds: [],
        dealerIds: [],
        oneLevelCode: null,
        twoLevelCode: null,
        threeLevelCode: null
      },
      this.pagination = {
        current: 1,
        size: 20,
        total: 0
      }
      this.queryByPage()
    },
    export2Excel() {
      this.ExportItem = 0
      this.disabled = this.$refs.xTable.getCheckboxRecords().length < 1
      this.dialogVisible = true
    },
    async outExcel() {
      this.outExcelButtonLocading = true
      let param = {}
      if (this.ExportItem == 0) {
        if (this.pagination.total > 10000) {
          this.$message.warning('导入' + this.pagination.total + '条，过程可能持续数分钟。')
        }
        param = {
          page: 1,
          limit: this.pagination.total,
          sort: this.sort,
          ...this.queryCondition,
          siftType: this.siftType
        }
      } else if (this.ExportItem == 1) {
        param = {
          page: this.pagination.current,
          limit: this.pagination.size,
          sort: this.sort,
          ...this.queryCondition
        }
      } else if (this.ExportItem == 2) {
        const idList = []
        this.$refs.xTable.selection.forEach(item => {
          idList.push(item.id)
        })
        param = {
          page: 1,
          limit: this.pagination.size,
          ids: idList,
          sort: this.sort,
          ...this.queryCondition
        }
      }
      exportWriteOff(param).then(val => {
        this.$exportExcelData(val, `活动执行核销列表 ${new Date().Format('yyyy年MM月DD日 HH点mm分')}.xlsx`)
        this.dialogVisible = false
        this.outExcelButtonLocading = false
      })
    },
    // 跳转详细
    DetailedFun(row) {
      this.$router.push({ path: `detailedReimbursement/${row.id}` })
    },

    deleteRow(row) {
      this.$confirm({
        title: '提示',
        content: '确定删除该活动？',
        onOk:() => {
          deleteActApply(row.id).then(res => {
            if (res.code === 1) {
              this.$message.success('删除成功')
              this.queryByPage(1)
            } else {
              this.$message.error(res.message)
            }
          })
        },
        onCancel:() => {
          this.$message.info('已取消删除')
        },
      });
    },
    startApprove(row) {
      this.appdialogVisible = true
      this.currentRow = row
    },
    
    // 放弃核销
    relinquishFun(row) {
      // this.$confirm('此操作将放弃核销，是否继续', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // })
      //   .then(() => {
      //     const data = { id: row.id, planApplyCode: row.planApplyCode, writeoffStatus: '7' }
      //     relinquishWriteoff(data).then(() => {
      //       this.$message.success('操作成功')
      //       this.queryByPage()
      //     })
      //   })
      //   .catch(() => {
      //     this.$message({
      //       type: 'info',
      //       message: '已取消'
      //     })
      //   })

      this.$confirm({
        title: '提示',
        content: '此操作将放弃核销，是否继续？',
        onOk:() =>{
          const data = { id: row.id, planApplyCode: row.planApplyCode, writeoffStatus: '7' }
          relinquishWriteoff(data).then(() => {
            this.$message.success('操作成功')
            this.queryByPage()
          })
        },
        onCancel() {
          Message({
            message: '已取消',
            type: 'info'
          });
        },
      });
    },
    //  恢复核销（放弃核销后）
    recoWriteoffFun(row) {
      // this.$confirm('此操作将恢复核销，是否继续', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // })
      //   .then(() => {
      //     const data = { id: row.id, planApplyCode: row.planApplyCode, writeoffStatus: '0' }
      //     relinquishWriteoff(data).then(() => {
      //       this.$message.success('操作成功')
      //       this.queryByPage()
      //     })
      //   })
      //   .catch(() => {
      //     this.$message({
      //       type: 'info',
      //       message: '已取消'
      //     })
      //   })
        this.$confirm({
          title: '提示',
          content: '此操作将恢复核销，是否继续？',
          onOk:() =>{
            const data = { id: row.id, planApplyCode: row.planApplyCode, writeoffStatus: '0' }
            relinquishWriteoff(data).then(() => {
              this.$message.success('操作成功')
              this.queryByPage()
            })
          },
          onCancel() {
            Message({
              message: '已取消',
              type: 'info'
            });
          },
        });
    },
    // 跳转核销
    reimburseFun(row) {
      this.$router.push({ path: `executeReimbursement/${row.id}` })
    },
    cb() {
      // this.$store.commit('actVerListPage/updateShowFilter', !this.showFilter)
      this.showFilter = !this.showFilter
    },
    onClose() {
      this.batchDialogVisible = false
      this.batchApproveMsg = ''
    }
  }
}
</script>
<style lang="less" scoped>
.act-item {
  width: 300px;
  text-align: right;
  margin-bottom: 5px;
}
.filter-container {
  padding: 0 20px;
}
.AMargin {
  padding: 0 5px;
}

.color-red {
  color: red;
}
/deep/ .ant-select-selection--multiple  {
  height: 28px !important;
  min-height: 28px !important;
  line-height: 28px !important;
}
</style>
